import React, { useState } from 'react';
import Game from '../Game';
import Header from '../Header';
import RestartButtonContext from '../RestartContext/RestartContext';
export const LanguageContext = React.createContext();

function App() {
    const languageFromStorage = localStorage.getItem('language');
    const [language, setLanguage] = useState(
        languageFromStorage ? languageFromStorage : 'EN'
    );

    return (
        <RestartButtonContext>
            <LanguageContext.Provider value={{ language, setLanguage }}>
                <div className='wrapper'>
                    <Header />
                    <div className=''>
                        <Game />
                    </div>
                </div>
            </LanguageContext.Provider>
        </RestartButtonContext>
    );
}

export default App;
